var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.itemsToRefund, function (item, idx) {
        return _c(
          "div",
          _vm._b({ key: idx, staticClass: "refund-items" }, "div", item, false),
          [
            _c("div", { staticClass: "flex flex-col" }, [
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(item.stripe_order_item.productTitle) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "refund-amount" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        item.refundType === "tax"
                          ? "Tax refund:"
                          : "Custom refund:"
                      ) +
                      "\n           \n          "
                  ),
                  _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.formattedAmount(item.refundAmount, "USD")) +
                        "\n            "
                    ),
                    item.refundType === "partial"
                      ? _c("span", [_vm._v("(+ applicable taxes)")])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
          ]
        )
      }),
      _vm._v(" "),
      _vm.refundShipping
        ? _c("div", { staticClass: "refund-items" }, [
            _c("div", { staticClass: "flex flex-col" }, [
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n          Shipping Costs\n        "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "refund-amount" }, [
                  _vm._v("\n          Shipping refund:  \n          "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.formattedAmount(_vm.shippingTotal, "USD"))
                    ),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }